import React from 'react';

const ServiceBarge = () => {
  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-12" style={{ width: '100%', backgroundColor: '#000', borderRadius: '5px', padding: '10px', color: 'white', textAlign: 'left' }}>
          <h2>Your Satisfaction is Our Priority</h2>
          <p>Get the best services tailored just for you!</p>
          <div className="d-flex justify-content-center mt-4">
            <div style={{ flex: 1 }}></div>
            <button className="btn btn-light" style={{ borderRadius: '20px', marginBottom: 40 }}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceBarge;